module.exports = __webpack_public_path__ + "media/images/navbar/espace-perso-7b0c085c7fc2f990f1c8f6f942d7b8df.png";